import router from "../router";
import app from "../App.vue";

function validateUrlParam(param) {
  const invalidPatterns = ['javascript:', 'data:', '<', '>'];
  for (let pattern of invalidPatterns) {
    if (param && param.toLowerCase().includes(pattern)) {
      router.push({name: 'Error'});
    }
  }
  return param;
}

function isDomainAllowed(url) {
  try {
    const checkUrl = new URL(url);
    const hostname = checkUrl.hostname;

    // Check if hostname is allowed domain
    if (hostname.endsWith(import.meta.env.VITE_ALLOWED_DOMAIN)){
      return true;
    }
  } catch (error) {
    return false;
  }
}

function getQuery() {
  const query = window.location.search;
  const urlParams = new URLSearchParams(query);

  for (const [key,value] of urlParams.entries()){
    validateUrlParam(value)

    if (key === 'start_url')
    {
      // Check if the start_url is from an allowed domain
      if (!isDomainAllowed(value)) {
        router.push({ name: 'Error' });
        return null;
      }
    }
  }
  return query;
}

function getQueryParam(name) {
  const urlParams = new URLSearchParams(getQuery());
  return urlParams.get(name);
}

function getCountry(defCountry = "US") {
  const country = navigator.language.split(/[_ -]/)[1];
  return getQueryParam("country") || country || defCountry;
}

function getLanguage(defLanguage = "en") {
  const language = navigator.language.split(/[_ -]/)[0];
  return getQueryParam("language") || language || defLanguage;
}

function buildParameters() {
  const query = getQuery();
  const language = getLanguage();
  const country = getCountry();
  const urlParams = new URLSearchParams(query);

  return {
    language,
    country,
    access_key: urlParams.get("access_key"),
    session: urlParams.get("session"),
    expiration: urlParams.get("expiration"),
    signature: urlParams.get("signature"),
  };
}

function storeParameters() {
  const query = getQuery();
  let curr = getParameters();

  if (query === "") {
    return curr;
  }

  const language = getLanguage();
  const country = getCountry();
  const urlParams = new URLSearchParams(query);

  curr = {
    ...curr,
    ...{
      language,
      country,
      access_key: urlParams.get("access_key"),
      session: urlParams.get("session"),
      expiration: urlParams.get("expiration"),
      signature: urlParams.get("signature"),
    },
  };

  sessionStorage.setItem("or_params", JSON.stringify(curr));

  urlParams.delete("access_key");
  urlParams.delete("session");
  urlParams.delete("expiration");
  urlParams.delete("signature");
  urlParams.delete("language");
  urlParams.delete("country");

  // window.history.pushState({}, document.title, window.location.pathname);

  if (window.location.href.indexOf("?") > -1) {
    window.location = window.location.pathname;
  }

  return curr;
}

function getParameters() {
  return JSON.parse(sessionStorage.getItem("or_params") || "{}");
}

export {
  getLanguage,
  getCountry,
  getQuery,
  getQueryParam,
  storeParameters,
  getParameters,
  buildParameters,
};
